module.exports = __webpack_public_path__ + "img/NW.608317fb.webp";